import type { AiCapabilityPage } from "../schema.js";
import { LIVE, MANAGER_ROLES } from "./_shared.js";

/**
 * `FIX-MISTAKE` (@UC0210) — trang **redirect** (US-AIV2-0049): chat KHÔNG hỏi ô, KHÔNG có nút Đồng ý,
 * chỉ một câu giải thích + nút mở đúng màn hình `/groups/:groupId/activities` (ADR-0009 bất biến 5).
 * US-AIV2-0110 S10 (`@UC0259`): trước trỏ trang chủ nhóm `/groups/:groupId`; nay tab "Hoạt động" — bấm một dòng mở màn chi tiết nơi làm việc này.
 * Cửa mobile trang này chịu trách nhiệm (ba cửa sửa sai: sửa khoản chi CHƯA duyệt · đảo khoản chi đã ghi · bút toán sửa sổ). *
 * 🔴 VÌ SAO LÀ `redirect`, KHÔNG PHẢI trang có nút Đồng ý trong chat (CLAUDE.md §4): đảo bút toán là hành
 * động KHÔNG-ĐẢO-ĐƯỢC-LẦN-HAI — partial unique `WHERE txType='REVERSAL'` cho mỗi tx gốc đúng một lần
 * (§3.3), nên bấm nhầm lần nữa là 409 chứ không phải "làm lại". Việc như thế đi qua GUI, nơi người dùng
 * nhìn thấy khoản gốc trước khi bấm. Chat chỉ dắt tới đúng chỗ và NÓI THẲNG rằng sổ không xoá được.
 *
 * Gộp cả "sửa/xoá khoản chi chưa duyệt" và "hoàn tác ghi nhận" vào một trang là QĐ PO 17/09 mục 10 —
 * người dùng không phân biệt ba cửa đó, họ chỉ nói "ghi nhầm rồi".
 */
export const FIX_MISTAKE = {
  id: "FIX-MISTAKE",
  uc: "@UC0210",
  tier: "redirect",
  status: LIVE,
  roles: MANAGER_ROLES,
  flags: [],
  slots: [],
  llm: {
    description: "Sửa một khoản đã ghi nhầm: sửa khoản chi chưa duyệt, đảo một khoản chi đã ghi, hoặc ghi bút toán sửa sổ.",
    examples: [
      "ghi nhầm rồi",
      "ghi nham roi",
      "lỡ ghi sai số tiền",
      "lo ghi sai so tien",
      "huỷ khoản chi vừa ghi",
      "xoá khoản chi ghi nhầm",
      "xoa khoan chi ghi nham",
      "sửa lại khoản vừa nhập",
      "nhập sai tiền rồi làm sao",
      "undo",
      "sửa sổ",
      "bấm nhầm",
      // ——— 0105: thêm cho đủ 40 ———
      "sua lai khoan vua nhap",
      "nhap sai tien roi lam sao",
      "sua so",
      "bam nham",
      "hoàn tác khoản vừa ghi",
      "hoan tac khoan vua ghi",
      "ghi sai số tiền, sửa lại được không?",
      "ghi sai so tien sua lai duoc khong",
      "đảo lại khoản chi hôm qua",
      "dao lai khoan chi hom qua",
      "tôi ghi nhầm 500k thành 5 triệu",
      "toi ghi nham 500k thanh 5 trieu",
      "khoản chi này ghi sai, bỏ đi giúp",
      "khoan chi nay ghi sai bo di giup",
      "sửa lại bút toán ghi sai",
      "sua lai but toan ghi sai",
      "lỡ nhập hai lần cùng một khoản",
      "lo nhap hai lan cung mot khoan",
      "huỷ khoản chi nhập nhầm",
      "huy khoan chi nhap nham",
      "gõ sai nội dung khoản chi, sửa giúp",
      "go sai noi dung khoan chi sua giup",
      "ghi nhầm vào quỹ khác rồi",
      "ghi nham vao quy khac roi",
      "muốn sửa lại sổ đã ghi sai",
      "muon sua lai so da ghi sai",
      "xoá bút toán nhầm",
      "xoa but toan nham",
      "làm sao sửa khoản đã ghi?",
      "lam sao sua khoan da ghi",
    ],
  },
  screen: "/groups/:groupId/activities",
  screenShows: "transaction_correct",
  endpoints: [
    "PATCH /expenses/{expenseId}",
    "POST /expenses/{expenseId}/reversal",
    "POST /funds/{fundId}/ledger-corrections",
    // 🔴 US-E14.F1-0848 — ĐƯỜNG ĐỌC của chính câu chuyện này: "đã sửa mấy lần, vì sao, ai sửa".
    // Thuộc trang FIX-MISTAKE chứ không phải trang mới: người dùng không phân biệt "sửa" với "xem
    // đã sửa gì" — họ chỉ nói *"ghi nhầm rồi"* (cùng lý lẽ QĐ PO 17/09 mục 10 đã gộp ba cửa sửa).
    // Vẫn `redirect`: khối lịch sử nằm TRONG màn Chi tiết hoạt động, chat chỉ dắt tới đó.
    "GET /funds/{fundId}/transactions/{txId}/correction-history",
  ],
  facts: [],
  templates: {
    // 🔴 AI-SO-DRIFT-1012 (@UC0210 · QĐ người dùng 12/10/2026): nút «Hoàn lại khoản chi» TẠM TẮT (`activity_detail_screen.dart`
    // `_reverseExpenseEntryEnabled = false`) ⇒ câu không hứa huỷ/đảo khoản chi; nói đúng việc màn chi tiết làm được (số tiền qua sửa nhầm,
    // ghi chú — tên/ngày ở dòng chi quỹ) + nói thẳng huỷ hẳn khoản chi tạm chưa làm được. Chỉ đổi câu, `llm.*` giữ (0 ca eval đổi).
    redirect:
      "Mình mở tab «Hoạt động» của nhóm — bạn bấm vào khoản ghi nhầm để sửa số tiền hoặc ghi chú (khoản chi quỹ sửa được cả tên và ngày). Sổ quỹ không xoá được: sửa số tiền sẽ ghi một khoản ĐẢO LẠI kèm khoản đúng, khoản cũ vẫn nằm nguyên trong lịch sử để ai cũng đối chiếu được. Còn huỷ hẳn một khoản chi thì hiện chưa làm được trong app.",
  },
  journey: { after: ["READ-FUND-MONEY"] },
  help: { title: "Sửa khoản ghi nhầm", tryNow: "ghi nhầm rồi" },
} satisfies AiCapabilityPage;
